export default function (interpolator, n) {
  var samples = new Array(n);

  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));

  return samples;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-interpolate@1.1.6@d3-interpolate/src/quantize.js
// module id = 221
// module chunks = 0 1 2